module.exports = __webpack_public_path__ + "static/Persefoni-e609aa122605a64956d5a4214f792218.jpg";